"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.HelpPane = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Link = require("@fluentui/react/lib/Link");

var _AppPanel = require("@uifabric/portal-ux/lib/AppPanel");

var React = _interopRequireWildcard(require("react"));

var _i18n = _interopRequireDefault(require("../../i18n"));

var optionsStyles = require('../OptionsPane/Options.scoped.scss');
/**
 * Represents a standard simple help dialog
 */


var APP_FRENCH_ACCESSIBILITY_LINK = 'https://www.microsoft.com/fr-fr/accessibility/accessibilite/accessibility-statement';
var APP_ITALY_ACCESSIBILITY_LINK = 'https://www.microsoft.com/it-it/accessibility/declarations';

var HelpPane = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(HelpPane, _React$Component);

  var _super = (0, _createSuper2.default)(HelpPane);

  function HelpPane() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, HelpPane);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));

    _this.renderFooter = function () {
      var t = _this.props.t;
      var options = {
        year: 'numeric'
      };
      var currentYear = new Date().toLocaleDateString(_i18n.default.language, options);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: optionsStyles.footerNotice,
        children: t('©{{currentYear}} Microsoft', {
          currentYear: currentYear
        })
      });
    };

    return _this;
  }

  (0, _createClass2.default)(HelpPane, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          helpVisible = _this$props.helpVisible,
          hideHelp = _this$props.hideHelp;
      var headerText = t('Help');
      var accessibilityLink = this.getAccessibilityLink();
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_AppPanel.AppPanel, {
        isOpen: helpVisible,
        onDismiss: hideHelp,
        headerText: headerText,
        closeButtonAriaLabel: t('CloseDialog', {
          dialogName: headerText
        }),
        isFooterAtBottom: true,
        onRenderFooterContent: this.renderFooter,
        children: [process.env.APP_FEEDBACK_URL ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
            href: process.env.APP_FEEDBACK_URL,
            target: "_blank",
            children: t('Provide feedback')
          })
        }) : null, process.env.APP_HELP_URL ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
            href: process.env.APP_HELP_URL,
            target: "_blank",
            children: t('Help')
          })
        }) : null, process.env.APP_PRIVACY_URL ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
            href: process.env.APP_PRIVACY_URL,
            target: "_blank",
            children: t('Privacy & cookies')
          })
        }) : null, process.env.APP_TERMS_OF_SERVICE_URL ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
            href: process.env.APP_TERMS_OF_SERVICE_URL,
            target: "_blank",
            children: t('Terms of service')
          })
        }) : null, accessibilityLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
            href: accessibilityLink,
            target: "_blank",
            children: t('accessibilityLinkText')
          })
        }) : null]
      });
    }
  }, {
    key: "getAccessibilityLink",
    value: function getAccessibilityLink() {
      if (!_i18n.default.languages) return undefined;

      switch (_i18n.default.languages[0].toLowerCase()) {
        case 'fr-fr':
          return APP_FRENCH_ACCESSIBILITY_LINK;

        case 'it-it':
          return APP_ITALY_ACCESSIBILITY_LINK;

        default:
          return undefined;
      }
    }
  }]);
  return HelpPane;
}(React.Component);

exports.HelpPane = HelpPane;